module.exports = __webpack_public_path__ + "app/components/global-search/users-search.view.html";